import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportMetrics = ({ metrics, processingReports }) => {
  const metricsConfig = [
    {
      key: 'totalScheduled',
      label: 'Total Scheduled Reports',
      icon: 'Calendar',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      trend: '+8',
      trendLabel: 'vs last month'
    },
    {
      key: 'successfulExports',
      label: 'Successful Exports',
      icon: 'CheckCircle',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      trend: '+12%',
      trendLabel: 'success rate'
    },
    {
      key: 'pendingGenerations',
      label: 'Pending Generations',
      icon: 'Clock',
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      trend: processingReports?.length > 0 ? 'Processing...' : 'Idle',
      trendLabel: 'current status'
    },
    {
      key: 'storageUtilization',
      label: 'Storage Utilization',
      icon: 'HardDrive',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      trend: `${metrics?.storageUtilization}%`,
      trendLabel: 'of 100GB used'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricsConfig?.map((metric) => (
        <div key={metric?.key} className="card">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                {metrics?.[metric?.key]}
              </h3>
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-primary">
                  {metric?.trend}
                </span>
                <span className="text-xs text-muted-foreground">
                  {metric?.trendLabel}
                </span>
              </div>
            </div>
            <div className={`p-3 rounded-lg ${metric?.iconBg}`}>
              <Icon name={metric?.icon} size={20} className={metric?.iconColor} />
            </div>
          </div>
          {metric?.key === 'pendingGenerations' && processingReports?.length > 0 && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                <span className="text-xs text-muted-foreground">
                  {processingReports?.length} report(s) generating
                </span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReportMetrics;